// Rules are documented here https://vrk-ewiki.eden.csc.fi/display/HETI/Tarkkeet
export const upperCaseUtf8ToAh033TransliterationRules = {
  Ă: 'A',
  Ą: 'A',
  Ā: 'A',
  Ć: 'C',
  Č: 'C',
  Ĉ: 'C',
  Ċ: 'C',
  Ď: 'D',
  Đ: 'D',
  Ĕ: 'E',
  Ę: 'E',
  Ė: 'E',
  Ē: 'E',
  Ǧ: 'G',
  Ğ: 'G',
  Ǥ: 'G',
  Ģ: 'G',
  Ĝ: 'G',
  Ġ: 'G',
  Ȟ: 'H',
  Ħ: 'H',
  Ĥ: 'H',
  Ĭ: 'I',
  Į: 'I',
  Ĩ: 'I',
  İ: 'I',
  Ī: 'I',
  Ĳ: 'IJ',
  Ĵ: 'J',
  Ǩ: 'K',
  Ķ: 'K',
  Ĺ: 'L',
  Ľ: 'L',
  Ŀ: 'L',
  Ļ: 'L',
  Ł: 'L',
  Ń: 'N',
  Ň: 'N',
  Ŋ: 'N',
  Ņ: 'N',
  Ŏ: 'O',
  Ő: 'O',
  Ō: 'O',
  Œ: 'OE',
  Ŕ: 'R',
  Ř: 'R',
  Ŗ: 'R',
  Ś: 'S',
  Ș: 'S',
  Š: 'S',
  Ş: 'S',
  Ŝ: 'S',
  Ț: 'T',
  Ť: 'T',
  Ŧ: 'T',
  Ţ: 'T',
  Ŭ: 'U',
  Ű: 'U',
  Ų: 'U',
  Ů: 'U',
  Ũ: 'U',
  Ū: 'U',
  Ŵ: 'W',
  Ŷ: 'Y',
  Ÿ: 'Y',
  Ź: 'Z',
  Ž: 'Z',
  Ʒ: 'Z',
  Ǯ: 'Z',
  Ż: 'Z',
}
export const lowerCaseUtf8ToAh033TransliterationRules = {
  ă: 'a',
  ą: 'a',
  ā: 'a',
  ć: 'c',
  č: 'c',
  ĉ: 'c',
  ċ: 'c',
  ď: 'd',
  đ: 'd',
  ĕ: 'e',
  ę: 'e',
  ė: 'e',
  ē: 'e',
  ǧ: 'g',
  ğ: 'g',
  ǥ: 'g',
  ģ: 'g',
  ĝ: 'g',
  ġ: 'g',
  ȟ: 'h',
  ħ: 'h',
  ĥ: 'h',
  ĭ: 'i',
  į: 'i',
  ı: 'i',
  ĩ: 'i',
  ī: 'i',
  ĳ: 'ij',
  ĵ: 'j',
  ǩ: 'k',
  ķ: 'k',
  ĺ: 'l',
  ľ: 'l',
  ŀ: 'l',
  ļ: 'l',
  ł: 'l',
  ń: 'n',
  ň: 'n',
  ŋ: 'n',
  ņ: 'n',
  ŏ: 'o',
  ő: 'o',
  ō: 'o',
  œ: 'oe',
  ŕ: 'r',
  ř: 'r',
  ŗ: 'r',
  ś: 's',
  ș: 's',
  š: 's',
  ş: 's',
  ŝ: 's',
  ț: 't',
  ť: 't',
  ŧ: 't',
  ţ: 't',
  ŭ: 'u',
  ű: 'u',
  ų: 'u',
  ů: 'u',
  ũ: 'u',
  ū: 'u',
  ŵ: 'w',
  ŷ: 'y',
  ÿ: 'y',
  ź: 'z',
  ž: 'z',
  ʒ: 'z',
  ǯ: 'z',
  ż: 'z',
}

export const utf8ToAh033TransliterationRules = {
  ...lowerCaseUtf8ToAh033TransliterationRules,
  ...upperCaseUtf8ToAh033TransliterationRules,
}
